import request from '../utils/request';

//角色列表
export function getRoleList(data) {
    return request({
        url: 'home/admin/role_list',
        method: 'post',
        data: data,
    });
}
// 添加/修改 (修改只改名称)
export function saveRole(data) {
    return request({
        url: 'home/admin/role_save',
        method: 'post',
        data: data,
    });
}
// 删除
export function delRole(data) {
    return request({
        url: 'home/admin/role_del',
        method: 'post',
        data: data,
    });
}
// 删除
export function getAccessList(data) {
    return request({
        url: 'home/admin/access_list',
        method: 'post',
        data: data,
    });
}
// 获取用户信息
export function getUserinfo(data) {
    return request({
        url: 'home/admin/info',
        method: 'post',
        data: data,
    });
}
// 修改用户信息
export function updateUserinfo(data) {
    return request({
        url: 'home/admin/save',
        method: 'post',
        data: data,
    });
}


// 修改用户信息
export function roleList(data) {
    return request({
        url: 'home/role/list',
        method: 'post',
        data: data,
    });
}



// 查看金额明细
export function seeFinancial(data) {
    return request({
        url: 'home/user/financial_log',
        method: 'post',
        data: data,
    });
}

// 获取用户权限
export function UpdateLimitData(data) {
    return request({
        url: 'home/admin/access_list',
        method: 'post',
        data: data,
    });
}
